module.exports = __webpack_public_path__ + "static/media/linkedin.00749be5.svg";